import useFilterQuerySecondary from './use-filter-query-secondary';
import useApartmentsLimitsSecondary from './use-apartments-limits-secondary';

const useLimitsSecondary = (fetch = true, marketType = 'Primary') => {
  const filter = useFilterQuerySecondary();
  return useApartmentsLimitsSecondary({ ...filter, marketType }, fetch);
};

export default useLimitsSecondary;
